
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Karandak Auditions- Pune </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Karandak Auditions <span > - Pune</span></h2>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-justify">जी. एच. रायसोनी स्पोर्ट्स अँड कल्चरल फाउंडेशनने आयोजित केलेल्या जी. एच. रायसोनी करंडक राज्यस्तरीय आंतरमहाविद्यालयीन एकांकिका स्पर्धेच्या कोल्हापूरच्या विजेत्यांची नावे खालीलप्रमाणे :

                        प्रथम पारितोषिक - नाटक "व्हाय नॉट?"
                        के. ई. सोसायटी, राजारामबापू इन्स्टिट्यूट ऑफ टेक्नॉलॉजी

                        द्वितीय पारितोषिक - नाटक "पॉझिटीव्ह"
                        आर्ट्स कॉमर्स अँड सायन्स कॉलेज, नागठाणे, सातारा

                        तृतीय पारितोषिक - नाटक "बांध"
                        डिपार्टमेंट ऑफ टेक्नॉलॉजी, शिवाजी युनिव्हर्सिटी

                        सर्व विजेत्यांना पुढील वाटचालीसाठी शुभेच्छा! </p>


                </div>
            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row">
            <div class="col-lg-6">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-2">
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-1.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-1.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-1.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-2.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-2.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-2.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-3.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-3.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-3.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <!-- <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-4.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-4.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-4.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li> -->
                            <li class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-5.jpg"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-5.jpg">
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/karandak-aud-pune-5.jpg"
                                        alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img
                                            src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
